import { Pipe, PipeTransform } from '@angular/core';
import { MonNumberService } from '@monsido/core/locale/services/mon-number.service';


@Pipe({
    name: 'monNumber',
    standalone: true,
})
export class MonNumberPipe implements PipeTransform {
    constructor (private monNumberService: MonNumberService) {}
    transform (value: number, format: string): string {
        return this.monNumberService.transformNumber(value, format);
    }
}
